/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AdminChangeHistory} from '../models/AdminChangeHistory';
import type {Error} from '../models/Error';

export interface GetAdminProfileChanges$Request {
    adminId: number;
    pageNumber?: number;
    pageSize?: number;
}

export interface GetAdminProfileChanges$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAdminProfileChangesRequest = createAction<PayloadData<void, GetAdminProfileChanges$Request>>('ADMIN_PROFILE_CHANGES__GET_ADMIN_PROFILE_CHANGES__REQUEST');
export const getAdminProfileChangesSuccess = createAction<PayloadData<AdminChangeHistory, GetAdminProfileChanges$Request>>('ADMIN_PROFILE_CHANGES__GET_ADMIN_PROFILE_CHANGES__SUCCESS');
export const getAdminProfileChangesFailure = createAction<PayloadData<Error, GetAdminProfileChanges$Request, true>>('ADMIN_PROFILE_CHANGES__GET_ADMIN_PROFILE_CHANGES__FAILURE');

export const getAdminProfileChangesActions = [
    getAdminProfileChangesRequest,
    getAdminProfileChangesSuccess,
    getAdminProfileChangesFailure
] as const;

/**
 * @param {number} meta.adminId
 * @param {number} [meta.pageNumber]
 * @param {number} [meta.pageSize]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAdminProfileChanges = (meta: GetAdminProfileChanges$Request, config?: GetAdminProfileChanges$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageNumber: meta.pageNumber,
        pageSize: meta.pageSize,
    };
    return {
        CALL_API: {
            types: getAdminProfileChangesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/admins/${meta.adminId}/audit-logs`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

